import { lazy } from "react";
import type { RouteConfig } from "../config";

/**
 * Rotas só de desenvolvimento. `import.meta.env.DEV` é substituído por `false` na build, o ramo morre e o Rollup nem
 * emite o chunk da galeria: nada disto chega à produção. O path é literal (e não em `ROUTES`) de propósito, para o
 * manual (`check:help`) não exigir uma entrada sobre uma página que os clientes nunca veem.
 */
export const devRoutes: RouteConfig[] = import.meta.env.DEV
  ? [
      {
        path: "/dev/design-system",
        component: lazy(() =>
          import("@/pages/dev/design-system-page").then((m) => ({ default: m.DesignSystemPage }))
        ),
        layout: "public",
        permissions: { access: "public" },
      },
    ]
  : [];
